export const rootClassName = "purpur-footer";
